<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">订单管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">订单列表</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="clue-search">
            <div class="left">
                <a-select style="width: 120px" allowClear @change="orderhandleChange" placeholder="订单状态" :showArrow="show">
                    <a-select-option v-for="(option,x) in orderoption" :key="x" :value="option.id">
                        {{option.name}}
                    </a-select-option>
                </a-select>
                <!-- 标签 -->
                <a-select style="width: 120px" allowClear @change="typehandleChange" placeholder="支付状态" :showArrow="show">
                    <a-select-option v-for="(option,x) in typeoption" :key="x" :value="option.id">
                        {{option.name}}
                    </a-select-option>
                </a-select>
            </div>
            <!-- 来源 -->

            <div class="right" style="display:flex">
                <a-input v-model="telephone_jh" style="width:160px;margin-right:6px" placeholder="激活号码"></a-input>
                <a-input-search
                    placeholder="关键字（用户名/订单号）"
                    enter-button="查询"
                    @search="onSearch"
                    v-model="searchtext"
                    >
                    
                </a-input-search>
            </div>
             
        </div>

        <div class="data-list">
            <a-spin :spinning="tablespinning">
                <a-table  rowKey="orid" :scroll="{x: 1300}" :pagination="pageshow" :columns="columns" :data-source="data">
                    <router-link slot="name" slot-scope="text,record" :to="{path:'orderdetail',query: {id:record.orid}}" >
                        {{ text }}
                    </router-link>

                    <span slot="status" slot-scope="text">
                        <a-tag v-if="text==0" color="orange">待发货</a-tag>
                        <a-tag v-if="text==1" color="green">未签收</a-tag>
                    </span>
                     <span slot="address" slot-scope="text,record">
                        {{record.province}}{{record.city}}{{record.area}}{{text}}
                    </span>

                    <span slot="phone" slot-scope="text">
                        <a style="display:block" v-for="item,i in text" :key="i" target="_blank" :href="item.url">{{item.telephone}}</a>
                    </span>

                     <span slot="fh" slot-scope="text">
                        <a-tag v-if="text==0" color="orange">未发货</a-tag>
                        <a-tag v-if="text==1" color="blue">已发货</a-tag>
                        <a-tag v-if="text==2" color="green">已签收</a-tag>
                        <a-tag v-if="text==3" color="orange">拒收</a-tag>
                    </span>

                     <span slot="pay" slot-scope="text">
                        <a-tag v-if="text==0" color="orange">未支付</a-tag>
                        <a-tag v-if="text==1" color="green">已支付</a-tag>
                        <a-tag v-if="text==3" color="blue">已退款</a-tag>
                    </span>

                    <span slot="date" slot-scope="text">
                        <span v-if="text">{{text | formatDate }}</span>
                        <span v-else>--</span>
                    </span>

                    <span slot="datetime" slot-scope="text">
                        <span v-if="text">{{text | showDate }}</span>
                        <span v-else>--</span>
                    </span>

                    <!-- <a style="color:#1890ff;display:flex;align-items: center;" slot="phone" slot-scope="text,record" @click="totel(record.id)">
                        <a-icon type="phone" theme="filled"/> <span style="margin-left:3px">{{text}}</span>
                    </a> -->
                    <span slot="action" slot-scope="text,record">
                        <a v-if="record.tracknumber==null" href="javascript:;" @click="toedit(record.orid)" style="margin-right:12px"><a-icon type="edit" /> 订单修改</a> 
                        <a href="javascript:;" @click="todelive(record.orid)" style="margin-right:12px"><a-icon type="export" /> 发货</a>                        
                        <router-link :to="{path:'orderdetail',query: {id:record.orid}}"><a-icon type="copy"/> 详情</router-link>
                    </span>
                </a-table>

                <div style="padding-top:30px;width: auto;display: flex;align-items: center;justify-content: flex-start;margin: 15px 12px 12px;">
                    <div class="page-total">总计：{{pagination.total}}条 / {{totalpage}}页</div>
                    <a-pagination
                    show-size-changer
                    :default-current="1"
                    :page-size-options="pageSizeOptions"
                    :total="pagination.total"
                    :defaultPageSize="10"
                    @change="handleTableChange"
                    @showSizeChange="onShowSizeChange"
                    >
                        <template slot="buildOptionText" slot-scope="props">
                            <span>{{ props.value }}条/页</span>
                        </template>

                    </a-pagination>
                </div>
            </a-spin>
        </div>

        <!-- 更改信息 -->
        <a-modal
        title="更改信息"
        :visible="editvisible"
        @cancel="handleCancel"
        cancelText="取消"
        okText="确定"
        @ok="edithandleOk"
        >
            <a-form name="editform" class="dataform" :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }">
                 <a-form-item label="用户名">
                
                    <a-input v-model="orderinfo.username" placeholder="请输入用户名"/>
                </a-form-item>
                 <a-form-item label="电话">
                
                    <a-input v-model="orderinfo.telephone" placeholder="请输入电话"/>
                </a-form-item>
                <a-form-item label="地址">
                    <div style="dispaly:flex;justify-content: space-around;">
                        <a-cascader v-model="ssq"  :field-names="{ label: 'name', value: 'name', children: 'area' }" @change="onaddressChange" :options="adddata" placeholder="请选择省、市、区"  />
                    </div>
                
                    <a-input v-model="address" placeholder="请输入详细地址"/>
                </a-form-item>
            </a-form>
        </a-modal>


        <!-- 发货 -->
        <a-modal
        title="发货"
        :visible="delivevisible"
        @cancel="handleCancel"
        cancelText="取消"
        okText="发货"
        @ok="khhandleOk"
        >
            <div class="deliver" >

                <div class="orderinfo orderform">
                    <span class="title">姓名：</span><span>{{orderinfo.username}}</span>
                    <span class="title" style="margin-left: 20px;">电话：</span><span>{{orderinfo.telephone}}</span>
                    <span class="title" style="margin-left: 20px;">卡数：</span><span>{{orderinfo.num}}</span>
                    <p><span class="title">地址：</span>{{orderinfo.province}}{{orderinfo.city}}{{orderinfo.area}}{{orderinfo.address}}</p>
                    <p><span class="title">套餐：</span>{{orderinfo.title_goods_setmeal}}</p>
                    <!-- <a-form class="dataform" :label-col="{ span: 3 }" :wrapper-col="{ span: 16 }"> -->

                    <!-- </a-form> -->
                </div>
                <a-form class="dataform" :form="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }">
                    <a-form-item label="订单号" >
                        <a-input v-model="orderno" disabled=""/>
                    </a-form-item>
                    <a-form-item label="快递单号" >
                        <a-input v-model="order.tracknumber" />
                    </a-form-item>
                    <div v-for="(i) in goodslist" :key="i.gdid">
                        <a-form-item label="手机号" ref="telephone" >
                            <a-input v-model="i.telephone" />
                        </a-form-item>
                        <a-form-item label="ICCID" ref="iccid" >
                            <a-input v-model="i.iccid" />
                        </a-form-item>
                        <a-divider />
                    </div>

                </a-form>
            </div>
            
        </a-modal>

    </div>
    
</template>

<script>
import {formatDate} from '../../utils/formate.js'
import addresslist from '../../../static/address.json'
const columns = [
    {title: 'ID',dataIndex: 'orid',key: 'orid',fixed: 'left',width:80},
    {title: '订单号',dataIndex: 'orderno',key: 'orderno',width:160},
    {title: '快递单号',dataIndex: 'tracknumber',key: 'tracknumber',width:160},
    {title: '激活号码',dataIndex: 'telephones',key: 'telephones',width:160,scopedSlots: { customRender: 'phone' }},
    {title: '支付状态',dataIndex: 'state_pay',key: 'state_pay',scopedSlots: { customRender: 'pay' },width:100},
    {title: '发货状态',dataIndex: 'state',key: 'state',scopedSlots: { customRender: 'fh' },width:100},
    {title: '姓名',dataIndex: 'username',key: 'username',scopedSlots: { customRender: 'name' },width:100},
    {title: '电话',dataIndex: 'telephone',key: 'telephone',width:130},
    {title: '地址',dataIndex: 'address',key: 'address',width:180,scopedSlots: { customRender: 'address' },ellipsis: true},
    {title: '套餐',dataIndex: 'title_goods_setmeal',key: 'title_goods_setmeal',width:150},
    {title: '卡数',dataIndex: 'num',key: 'num',width:80},
    {title: '添加时间',dataIndex: 'addtime',key: 'addtime',scopedSlots: { customRender: 'datetime' },width:110},
    {title: '发货日期',dataIndex: 'sendtime',key: 'sendtime',scopedSlots: { customRender: 'datetime' },width:110},
    {title: '收货日期',dataIndex: 'receivtime',key: 'receivtime',width:110},
    {title: '操作',key: 'action',scopedSlots: { customRender: 'action' },fixed: 'right',width:260},
];

export default {
    filters: {
      //年-月-日
      formatDate (time) {
        time = time * 1000
        let date = new Date(time)
        return formatDate (date, 'yyyy-MM-dd')
      },

      showDate(time){
          time = time * 1000
        let date = new Date(time)
        return formatDate (date, 'yyyy-MM-dd hh:mm:ss')
      }
    },
    props: {
		inputNums: {
			type: Number,
			default: 19
		},
		value: {
			type: String,
			default: ''
		}
	},
    data(){
        const adddata = [];
        return{
            code: this.value.split(''),
            
            editvisible:false,
            show:true,
            lyoption:["来源1","来源2"],
            orderoption:[{name:'全部',id:""},{name:'未发货',id:"0"},{name:'已发货',id:"1"},{name:'已签收',id:"2"},{name:'拒收',id:"3"}],
            typeoption:[{name:'全部',id:""},{name:'已支付',id:"1"},{name:'已退款',id:"3"}],
            kdoption:["快递一"],
            searchtext:"",
            tstext:"",
            tablespinning:true,
            tabley:"",
            tablex:"100%",
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
            columns,
            data:[],
            pagination:{
                total:20
            },
            totalpage:2,
            pageshow:false,
            currentpagination:"",
            pageSizeOptions:['10','20','30','40','100','200'],

            delivevisible:false,
            form: this.$form.createForm(this, { name: 'coordinated' }),
            ordernum:[{"id":0}],
            position:0,
            size:10,

            iccidlist:[],
            len:0,
            order:{
                orid:"",
                state:1,
                tracknumber:""
            },
            orderno:"",//订单号
            goodslist:[],
            orderinfo:"",

            city:"",
            area:"",
            address:"",
            province:"",

            editid:"",
            state_pay:"",
            state:"",

            addressinfo:"",
            ssq:[],

            msgname:"",
            msgtel:"",
            msgorderno:"",
            
            telephone_jh:""

        }
    },
    watch: {
        windowHeight (val) {
            this.tablex=val-300
        },
        value(newVal){
            this.code = newVal.split('');
        },
        code(newVal){
            this.$emit('input',newVal.join(''));
        }
    },
    created(){
        //修改的data值为JSON文件中想要的数据
        this.adddata = addresslist;
    },

    mounted(){
        
        this.fetch()

        window.fullWidth = document.documentElement.clientWidth;
        this.windowWidth = window.fullWidth;  
        this.tablex=this.windowWidth-300
        window.onresize = () => {
            return (() => {
                window.fullWidth = document.documentElement.clientWidth;
                this.windowWidth = window.fullWidth;  // 高
                this.tablex=this.windowWidth-300
            })()
        };
    },
    methods:{
        // 订单修改
        toedit(id){
            this.editid=id
            this.getdetail(id)
            this.editvisible=true
        },
        edithandleOk(){
             this.$axios.post('/api/order/updateorder',{
                orid:this.editid,
                username: this.orderinfo.username,
                telephone:this.orderinfo.telephone,
                province:this.province,
                city:this.city,
                area:this.area,
                address:this.address
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success(res.data.msg); 
                    this.editvisible=false
                    this.province="",
                    this.city="",
                    this.area="",
                    this.address=""
                    this.fetch()
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },
        onaddressChange(value){
            this.province=value[0]
            this.city=value[1]
            this.area=value[2]
        },

        // 来源筛选
        lyhandleChange(){

        },

        // 标签筛选
        typehandleChange(value){
            this.currentpage=1
            this.state_pay=value
            this.fetch()
        },

        // 订单状态筛选
        orderhandleChange(value){
            this.currentpage=1
            this.state=value
            this.fetch()
        },

        // 号码查询
        handleserach(){

        },
        onSearch(){
            this.fetch()
        },

        // 分页
        handleTableChange(pageNumber) {
            this.currentpage=pageNumber
            this.fetch();
        },
        onShowSizeChange(current,pageSize){
            this.size=pageSize
            this.page=1
            this.fetch();
        },


        // 数据
        fetch(){
            this.$axios.post('/api/order/orderlist',{
                pagesize: this.size,
                page:this.currentpage,
                state_pay:this.state_pay,
                state:this.state,
                search:this.searchtext,
                telephone_jh:this.telephone_jh
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.tablespinning=false
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.total;
                    pagination.pageSize=this.size
                     var data=res.data.data.data
                    for(var i in data){
                        data[i].telephones=JSON.parse(data[i].telephones)
                    }
                    this.data=data
                    this.pagination = pagination;
                    this.totalpage=Math.ceil(res.data.data.total/this.size)
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },

        // 增加iccid
        addiccid(){
            var len=this.len++
            this.ordernum.push({"id":len})
        },
        remove(i){
            console.log(this.ordernum)
            this.ordernum=this.ordernum.splice(i, i)

        },

        getdetail(id){
             this.$axios.post('/api/order/orderpage',{
                orid: id
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.msgname=res.data.data.orderpage.username
                    this.msgtel=res.data.data.orderpage.telephone
                    this.msgorderno=res.data.data.orderpage.orderno
                    this.orderinfo=res.data.data.orderpage
                    this.address=res.data.data.orderpage.address
                    var ssq=[]
                    ssq.push(res.data.data.orderpage.province)
                    ssq.push(res.data.data.orderpage.city)
                    ssq.push(res.data.data.orderpage.area)
                    this.ssq=ssq
                    this.order.orid=res.data.data.orderpage.orid
                    this.order.tracknumber=res.data.data.orderpage.tracknumber
                    this.orderno=res.data.data.orderpage.orderno
                    var goodslist=res.data.data.goodslist
                    for(var i in goodslist){
                        this.$delete(goodslist[i], 'goodsname')
                        this.$delete(goodslist[i], 'orid')
                        this.$delete(goodslist[i], 'state')
                        this.$delete(goodslist[i], 'updatetime')
                        this.$delete(goodslist[i], 'addtime')
                    }
                    this.goodslist=goodslist
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },
        todelive(id,num){
            this.getdetail(id)
            this.delivevisible=true
     
        },

        handleCancel(){
            this.delivevisible=false
            this.editvisible=false
        },

        // 快递方式
        kdhandleChange(){

        },

        khhandleOk(){
            this.$axios.post('/api/order/delivergoods',{
                order:this.order,
                goodslist:this.goodslist
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$axios.get('https://fxbkfadmin.13524.net/alidysms/api_demo/SmsDemo.php?telephone='+this.msgtel+'&username='+this.msgname+'&orderno='+this.msgorderno+'&tracknumber='+this.order.tracknumber,{
                        // telephone:this.msgtel,
                        // username:this.msgname,
                        // orderno:this.msgorderno,
                        // tracknumber:this.order.tracknumber
                    },{
                        headers: {
                            "token":localStorage.getItem('token'),
                        }
                    }).then((res)=>{
                        if(res.data.code==200){
                        }else{
                            this.$message.warning(res.data.msg); 
                        }
                    
                    })
                    this.$message.success(res.data.msg); 
                    this.delivevisible=false
                    this.order.tracknumber=""
                    this.fetch()
                    
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },

    }
}
</script>





// WEBPACK FOOTER //
// src/components/order/orderlist.vue